import React, { useState, useRef, useEffect } from "react";
import LabelInput from "../../../Component/labelInput";
import PageTitle from "../../../module/pageTitle";
import { useDispatch } from "react-redux";
import { AppDispatch } from "../../../store";
import { getCategoryList, getProductTypeList } from "../../Admin/adminSlice";
import DropdownWithClear from "../../../Component/dropdownWithClear";
import { BookStatusList } from "../../../Utils/dataConstant";
import { productHistory, productHistoryDetails } from "../publicationSlice";
import VisibilityIcon from '@mui/icons-material/Visibility';
import { Submitbtn } from "../../../Component";
import moment from "moment";
import localImages from "../../../Constant/localImages";
import InvoicePopUP from "../../../Component/invoicePopUP";
import DatePicker from "../../../Component/datePicker";
import { showSnackbar, hideSnackbar } from "../../../store/slices/snackbarSlice";
const ProdctHistory = () => {
  const dispatch: Function = useDispatch<AppDispatch>();
  const inputRef = useRef<HTMLInputElement>(null);
  const [category, setCategory] = useState<any>("");
  const [categoryList, setCategoryList] = useState<any>([]);
  const [productTypeList, setProductTypeList] = useState<any>([]);
  const [productType, setProductType] = useState<any>("");
  const [bookStatus, setBookStatus] = useState<any>(0);
  const [productHistoryList, setProductHistoryList] = useState<any>([]);
  const [isEditMode, setisEditMode] = useState<Boolean>(false);
  const [productID, setProductID] = useState<any>("");
  const [productName, setProductName] = useState<any>("");
  const [openClose, setOpenClose] = useState(false);
  const [product, setProduct] = useState<any>("");
  const [startDate, setStartDate] = useState<any>(
    moment.utc(new Date()).format("YYYY-MM-DD")
  );
  const [endDate, setEndDate] = useState<any>(
    moment.utc(new Date()).format("YYYY-MM-DD")
  );;
  const [stockIn, setStockIn] = useState<any>("");
  const [productDetailsList, setProductDetailsList] = useState<any>([]);
  useEffect(() => {
    dispatch(
      getProductTypeList({
        callback: (res: any) => {
          setProductTypeList(res?.data);
        },
        errorCallback: () => { },
      })
    );
    dispatch(
      productHistory({
        params: {
          status: 0,
        },
        callback: (res: any) => {
          if (res?.status === "success") {
            dispatch(showSnackbar({ message: res?.msg, type: res?.status }));
            setTimeout(() => {
              dispatch(hideSnackbar());
            }, 5000);
            setProductHistoryList(res?.data);
          }
        },
        errorCallback: (error: any) => {
          dispatch(showSnackbar({ message: error?.data?.msg, type: error?.data?.status }));
          setTimeout(() => {
            dispatch(hideSnackbar());
          }, 5000);
        },
      })
    );
  }, []);

  const onChangeProductType = (value: any) => {
    const postData = {
      productTypeId: value?._id,
    };
    dispatch(
      getCategoryList({
        params: postData,
        callback: (res: any) => {
          setCategoryList(res);
        },
        errorCallback: (error: any) => { },
      })
    );
    setProductType(value);
  };

  const onchangeCategory = (value: any) => {
    setCategory(value);
  };

  const onchangeBookStatus = (value: any) => {
    setBookStatus(value);
  };

  const handleSubmit = (e: any) => {
    e.preventDefault();
    const postData = {
      status: bookStatus?._id,
      productTypeId: productType?._id,
      productCategoryId: category?._id,
    };

    dispatch(
      productHistory({
        params: postData,
        callback: (res: any) => {
          if (res?.status === "success") {
            setProductHistoryList(res?.data);
            dispatch(showSnackbar({ message: res?.msg, type: res?.status }));
            setTimeout(() => {
              dispatch(hideSnackbar());
            }, 5000);
          }
        },
        errorCallback: (error: any) => {
          dispatch(showSnackbar({ message: error?.data?.msg, type: error?.data?.status }));
          setTimeout(() => {
            dispatch(hideSnackbar());
          }, 5000);
        },
      })
    );
  };
  const handleViewMore = (data: any) => {
    setisEditMode(true);
    setProductID(data?._id);
    setProductName(data?.name);
    setProductType(data?.productTypeId?._id);
    setStockIn(data?.quantity);

    const postData = {
      productId: data?._id,
      startDate: moment(startDate).utcOffset(330).format("YYYY-MM-DD HH:mm:ss"),
      endDate: moment(endDate).utcOffset(330).format("YYYY-MM-DD HH:mm:ss"),
    }
    dispatch(
      productHistoryDetails({
        params: postData,
        callback: (res: any) => {
          setProductDetailsList(res?.data);
        },
        errorCallback: () => { },
      })
    );
  }

  const onchangeStartDate = (value: any) => {
    setStartDate(value);
  };
  const onchangeEndDate = (value: any) => {
    setEndDate(value);
  };

  const filterdata = (e: any) => {
    e.preventDefault();
    const postData = {
      productId: productID,
      startDate: moment(startDate).utcOffset(330).format("YYYY-MM-DD HH:mm:ss"),
      endDate: moment(endDate).utcOffset(330).format("YYYY-MM-DD HH:mm:ss"),
    }
    dispatch(
      productHistoryDetails({
        params: postData,
        callback: (res: any) => {
          setProductDetailsList(res?.data);
        },
        errorCallback: () => { },
      })
    );

  }
  const handleGoBack = () => {
    setisEditMode(false);
  };

  const validations1 = () => {
    return (
      category === "" ||
      productType === "" ||
      productTypeList?.length === 0 ||
      categoryList?.length === 0 ||
      bookStatus === ""
    )
  }
  const validation2 = () => {
    return (
      startDate === "" ||
      endDate === ""
    )
  }
  const renderTable = () => {
    return (
      <div className="  table-responsive my-3 pb-2">
        <table className="table table-striped table-hover align-middle text-md-start text-center ">
          <tr>
            <th>S.N</th>
            <th>BOOK NAME</th>
            <th>PRODUCT NAME</th>
            <th>CATEGORY NAME</th>
            <th>QUANTITY</th>
            <th>STATUS</th>
            <th>ACTION</th>
          </tr>
          <tbody>
            {productHistoryList?.map((item: any, index: any) => {
              return (
                <tr key={index}>
                  <td>{index + 1}</td>
                  <td className="col-md-3">{item?.name}</td>
                  <td>{item?.productTypeId?.name} </td>
                  <td>{item?.productCategoryId?.name} </td>
                  <td>{item?.quantity} </td>
                  <td>{item?.status} </td>
                  <td>
                    <button
                      type="button"
                      className="btn btn-outline-primary rounded-pill"
                      onClick={() => handleViewMore(item)}
                    >
                      View
                    </button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    )
  }

  const renderListMode = () => {
    return (
      <>
        <div className="bxshadow p-2 borderRadius mb-4">
          <form onSubmit={handleSubmit}>
            <div className="d-flex justify-content-between align-items-center mb-2">
              <div className=" col-md-4 p-2">
                <LabelInput labelName={"Product Type"} />
                <DropdownWithClear
                  labelName={"Product Type"}
                  setInputText={(val: any) => onChangeProductType(val)}
                  value={productType}
                  options={productTypeList}
                />
              </div>
              <div className=" col-md-4 p-2">
                <LabelInput labelName={"Product category "} />
                <DropdownWithClear
                  labelName={"Select Product category "}
                  setInputText={(value: any) => onchangeCategory(value)}
                  options={categoryList}
                  value={category}
                />
              </div>
              <div className=" col-md-4 p-2">
                <LabelInput labelName={"Book Status"} />
                <DropdownWithClear
                  labelName={"Select Book Status "}
                  setInputText={(value: any) => onchangeBookStatus(value)}
                  options={BookStatusList}
                  value={bookStatus}
                  defaultValue={BookStatusList[0]}
                />
              </div>
            </div>
            <div className="col-2 pt-2">
              <Submitbtn name={"Search"} disabled={validations1()} />
            </div>
          </form>
        </div>
        <div className="bxshadow p-2 borderRadius mb-4">
          {renderTable()}
        </div>
      </>)
  }
  const handleOpen = (item: any) => {
    window.open(item?.document, "_blank");
  }
  const handleClose = (value: any) => {
    setOpenClose(false);
  };

  const renderViewTable = () => {
    return (
      <div className="admin-table table-responsive">
        <table className="table table-striped table-hover align-middle text-md-start text-center">
          <thead>
            <tr>
              <th>S.N</th>
              <th>ADDED BY</th>
              <th>DATE & TIME</th>
              <th>LAST QUANTITY</th>
              <th>CURRENT QUANTITY</th>
              <th>QUANTITY</th>
              <th>ACTION</th>
              <th>FROM</th>
              <th>TO</th>
              <th>SEELING SOURCE</th>
              <th>INVOICE</th>
            </tr>
          </thead>
          <tbody>
            {productDetailsList?.map((item: any, index: any) => {
              return (
                <tr key={index}>
                  <td>{index + 1}</td>
                  <td>{item?.addedBy?.name}</td>
                  <td>{moment(item?.addedDate).format('DD-MM-YY')} {moment(item?.addedDate).format('LT')}</td>
                  <td>{item?.lastQuantity}</td>
                  <td>{item?.currentQuantity}</td>
                  <td>{item?.quantity}</td>
                  <td>{item?.status === 1 ? "In" : item?.status === 2 ? "Transfer" : item?.status === 3 ? "Sell" : item?.status === 4 ? "Return" : item?.status === 4 ? "Damaged In" : "-"} </td>
                  <td>{item?.from ? item?.from : "-"}</td>
                  <td>{item?.to ? item?.to : "-"} </td>
                  <td>{item?.sourceId?.name ? item?.sourceId?.name : "-"}</td>
                  <td className="cursor" onClick={() => handleOpen(item)}>{item?.document ? (<VisibilityIcon className="colorTheme1" />) : ("-")}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    )
  };
  const renderEditMode = () => {
    return (
      <>
        <div className="bxshadow p-3 borderRadius mb-4">
          <div className="d-flex justify-content-between align-items-center mb-2">
            <div className="">
              <p ><span className="fw-bold me-2">Product Name :<span className="fw-bold  colorTheme2"> {productName}</span></span></p>
            </div>
            <div className="">
              <p ><span className="fw-bold me-2">Available Stock: <span className="fw-bold  colorTheme2">{stockIn}</span></span></p>
            </div>
          </div>
          <form onSubmit={filterdata}>
            <div className="row align-items-center">
              <div className="col-md-4 p-3">
                <LabelInput labelName={"Start Date"} isRequired />
                <DatePicker
                  setInputText={(value: any) => {
                    onchangeStartDate(value);
                  }}
                  value={startDate}
                />
              </div>
              <div className="col-md-4 p-3">
                <LabelInput labelName={"End Date"} isRequired />
                <DatePicker
                  setInputText={(value: any) => {
                    onchangeEndDate(value);
                  }}
                  value={endDate}
                />
              </div>
              <div className="col-2 mt-4">
                <Submitbtn name={"Submit"} disabled={validation2()} />
              </div>
            </div>
          </form>
        </div>
        <div className="bxshadow p-2 borderRadius mb-4">
          {renderViewTable()}
        </div>
      </>
    )
  }

  return (
    <div className="panel-content">
      <div className="mb-4">
        <PageTitle
          name={"Product History"}
          breadCrumb={""}
          isEditMode={isEditMode}
          setisEditMode={setisEditMode}
          cancelEdit={() => handleGoBack()}
        />
      </div>
      <div className="formDiv">
        {!isEditMode ? renderListMode() : renderEditMode()}


      </div>
      <InvoicePopUP open={openClose} handleClose={handleClose} data={product} />
    </div>
  );
};

export default ProdctHistory;
